import React, { PureComponent } from 'react';
import { SegmentGroup } from 'svift-ui';

class SegmentGroupWrapper extends PureComponent {
	render() {
		return <SegmentGroup {...this.props} size="small" className="svift-dnd-list svift-folder-tree" />;
	}
}
export default SegmentGroupWrapper;